// @ts-nocheck
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import "./i18n";
import { RecoilRoot } from "recoil";
import { SWRConfig } from "swr";
import environmentConfig from "constants/config";
import "@qjumpers/common-ui/dist/index.css";
import { ApolloProvider } from "@apollo/client";
import apolloClient from "./middleware/apolloClient";
import IframeAuthWrapper from "./IframeApp";
import AuthRouter from "./AuthRouter";

const isSearchAndMatchPublicRoute = window.location.pathname === "/aitssearch";

const isIframeMode =
  window.location.pathname.startsWith("/iframe") ||
  window.location.search.includes("iframe=true") ||
  window.top !== window.self;

const AppRouter = () => {
  if (isSearchAndMatchPublicRoute || isIframeMode) {
    return <IframeAuthWrapper />;
  }

  return <AuthRouter />;
};

const clientStylesMap = {
  client1: () => import("./styles/client1/client.bootstrap.overides.scss"),
  client2: () => import("./styles/client2/client.bootstrap.overides.scss"),
};

const _getClientIdFromUrl = () => {
  const { hostname } = window.location;
  if (hostname.includes(".")) {
    const hostParts = hostname.split(".");
    if (hostParts.length >= 2) {
      const subdomain = hostParts[0];
      const commonSubdomains = ["www", "app", "admin", "api", "dev", "staging", "test"];
      if (!commonSubdomains.includes(subdomain.toLowerCase()) && subdomain.length > 0) {
        return subdomain.toLowerCase();
      }
    }
  }
  return null;
};

// Function to load client-specific styles
// Uses process.env.REACT_APP_CLIENT_SITE so webpack can tree-shake unused client SCSS at compile time
const loadClientStyles = async () => {
  try {
    const clientId = "client2";

    if (environmentConfig.isClientSite === "true") {
      if (clientId && clientStylesMap[clientId]) {

        // Call the function to import
        await clientStylesMap[clientId]();

      }

      console.log(`✅ Client-specific styles loaded for: ${clientId}`);
    } else {
      await import("./styles/bootstrap.overides.scss");
    }
  } catch (err) {
  }
};

// Load styles immediately
loadClientStyles();

ReactDOM.render(
  <ApolloProvider client={apolloClient}>
    <SWRConfig
      value={{
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        dedupingInterval: 50000,
      }}
    >
      <RecoilRoot>
        <Router>
          <AppRouter />
        </Router>
      </RecoilRoot>
    </SWRConfig>
  </ApolloProvider>,
  document.getElementById("root"),
);
